/**
 * Legacy helper retained for tests / one-off tooling.
 * Live UI should use organizations_label_singular from settings — do not derive at runtime.
 */
export function toSingular(label) {
    const value = String(label || "").trim();
    if (!value) {
        return "Organization";
    }

    if (/ies$/i.test(value)) {
        return value.replace(/ies$/i, "y");
    }

    if (/(ses|xes|zes|ches|shes)$/i.test(value)) {
        return value.replace(/es$/i, "");
    }

    if (/s$/i.test(value) && !/ss$/i.test(value)) {
        return value.replace(/s$/i, "");
    }

    return value;
}

/**
 * Resolve section (plural) and item (singular) org labels from shared Inertia globalSettings.
 * Both are admin-configured; singular is never derived from the section label at runtime.
 */
export function getOrganizationsLabels(globalSettings) {
    const plural =
        globalSettings?.organizations_label?.trim() || "Organizations";
    const singular =
        globalSettings?.organizations_label_singular?.trim() || "Organization";

    return { plural, singular };
}
